import styled, { css } from 'styled-components'
import { ControlSize } from 'types'
import { borderRadiusFromControlSize } from 'utils'

export const Container = styled.div<{ disabled: boolean }>`
    cursor: pointer;
    position: relative;

    ${({ disabled }) =>
        disabled &&
        css`
            pointer-events: none;
        `}
`

export const Playhead = styled.div<{ color: string; controlSize: ControlSize }>`
    box-sizing: content-box;
    height: 100%;
    pointer-events: none;
    position: absolute;
    will-change: transform;

    ${({ color, controlSize }) => {
        const borderSize = borderRadiusFromControlSize(controlSize)
        const borderMidSize = Math.round(borderSize / 2)

        return css`
            background: ${color};
            border-radius: ${borderMidSize}px;
            box-shadow: 0 0 ${borderSize}px rgba(0, 0, 0, 0.7);
            left: -${borderMidSize}px;
            padding: ${borderMidSize}px 0;
            top: -${borderMidSize}px;
            width: ${borderSize}px;
        `
    }}
`
